"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var PercentageStar = function PercentageStar(_ref) {
  var widthPercentage = _ref.widthPercentage,
    size = _ref.size,
    unfilledColor = _ref.unfilledColor;
  var offsetPercentage = Math.round(widthPercentage * 100);
  /* To create the star percentage we need to create a linearGradient mask
   if the mask id collides with another id, the browser defaults to a no-op
   and doesn't render the star, thus we need to ensure each maskId is unique
  */
  var randomId = Math.round(Math.random() * 100000);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    className: "percentage-star",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "offset-".concat(randomId)
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0%",
    stopColor: "#FAA500"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "".concat(offsetPercentage, "%"),
    stopColor: "#FAA500"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "".concat(offsetPercentage, "%"),
    stopColor: unfilledColor
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "100%",
    stopColor: unfilledColor
  }))), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "url(#offset-".concat(randomId, ")"),
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2466 35.1135C10.0601 35.7278 8.67346 34.7356 8.90005 33.4346L10.5718 23.8358L3.49016 17.038C2.53029 16.1166 3.05996 14.5113 4.38646 14.3214L14.1731 12.921L18.5498 4.18778C19.143 3.00406 20.857 3.00406 21.4502 4.18778L25.8269 12.921L35.6135 14.3214C36.94 14.5113 37.4697 16.1166 36.5098 17.038L29.4282 23.8358L31.0999 33.4346C31.3265 34.7356 29.9399 35.7278 28.7534 35.1135L20 30.5816L11.2466 35.1135Z"
  }));
};
PercentageStar.propTypes = {
  widthPercentage: _propTypes["default"].number,
  size: _propTypes["default"].string,
  unfilledColor: _propTypes["default"].string
};
PercentageStar.defaultProps = {
  widthPercentage: 0,
  size: '2em',
  unfilledColor: '#EAEAEA'
};
var _default = exports["default"] = PercentageStar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/assets/percentage-star.js
// module id = 2003
// module chunks = 25